import { ServiceDto } from "@gap/backend/app-services/services/models/ServiceDto";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import { observer } from "mobx-react-lite";
import useStore from "reusable/mobx-store-utils";
import ServiceAutocompleteStore from "./ServiceAutoCompleteStore";
import ServiceRenderOption from "./components/ServiceRenderOption";
import { useEffect } from "react";

export type ServiceOption = {
   name: string,
   description?: ServiceDto['description'],
   id?: string, // Allow to be undefined for the case of custom input
   category?: ServiceDto['category'],
   groupOption?: string,
   inputValue?: string,
   orgId?: string,
   howItWorks?: string | undefined
}

type AutocompleteType = AutocompleteProps<ServiceOption, false, false, true>

interface ServiceAutocompleteParams extends Omit<
   AutocompleteType,
   'options' | 'renderInput' | 'value' | 'onChange'
> {
   services: ServiceOption[],
   value?: string,
   onChange?: (value?: any) => any,
   onSelectPreconfiguredService?: (service: ServiceOption) => any
   helperText?: string
   error?: boolean
   label: string
}

export default observer(function ServiceAutocomplete(props: ServiceAutocompleteParams) {
   const serviceAutocompleteStore = useStore((params) => new ServiceAutocompleteStore(params), props)

   return <Autocomplete
      disablePortal
      value={serviceAutocompleteStore.value}
      options={props.services}
      autoFocus={props.autoFocus}

      freeSolo
      clearOnBlur
      selectOnFocus
      handleHomeEndKeys

      onChange={serviceAutocompleteStore.onChange}

      filterOptions={serviceAutocompleteStore.filterOptions}
      getOptionLabel={serviceAutocompleteStore.getOptionLabel}
      groupBy={serviceAutocompleteStore.groupOption}
      renderOption={ServiceRenderOption}
      renderGroup={serviceAutocompleteStore.renderGroup}
      PaperComponent={serviceAutocompleteStore.paperComponent}
      renderInput={serviceAutocompleteStore.renderInput}
   />
})

interface ServiceAutocompleteMultipleParams extends Omit<ServiceAutocompleteParams, 'value'> {
   value?: ServiceDto[],
   onNewServiceAdd?: (service: string | ServiceDto[]) => void
}

export const ServiceAutoCompleteMultiple = observer(function ServiceAutoCompleteMultiple(props: ServiceAutocompleteMultipleParams) {
   const sp = {
      ...props,
      values: props.value
   } as ServiceAutocompleteParams
   delete sp.value

   const serviceAutocompleteStore = useStore((params) => new ServiceAutocompleteStore(params), sp)

   // Listen for new changes
   useEffect(() => {
      serviceAutocompleteStore.values = props.value || []
   }, [props.value, serviceAutocompleteStore])

   return <Autocomplete
      multiple
      options={props.services}
      value={serviceAutocompleteStore.values}
      autoFocus={props.autoFocus}
      disableCloseOnSelect={true}

      disablePortal

      clearOnBlur
      selectOnFocus
      handleHomeEndKeys

      onChange={serviceAutocompleteStore.onChangeMultiple}

      filterOptions={serviceAutocompleteStore.filterOptions}
      getOptionLabel={serviceAutocompleteStore.getOptionLabel}
      groupBy={serviceAutocompleteStore.groupOption}
      renderOption={ServiceRenderOption}
      renderGroup={serviceAutocompleteStore.renderGroup}
      PaperComponent={serviceAutocompleteStore.paperComponent}
      renderInput={serviceAutocompleteStore.renderInput}
      renderTags={serviceAutocompleteStore.renderTags}

      isOptionEqualToValue={serviceAutocompleteStore.isOptionEqualToValue}
   />
})